define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ShiftsCollection = require("collections/entities/scheduling/ShiftsCollection");
    var ScheduleUtilities = require("utils/ScheduleUtilities");
    var Config = require("manager-assets/config/config.json");
    var DateUtility = require("utils/DateUtility");

    var NAME = "SpecialOccasionEventModel";

    var KEYS = {
        ID: "id",
        NAME :"name",
        START_DATE: "startDate",
        END_DATE: "endDate",
        TYPE: "type",
        SHIFTS: "shifts"
    };

    var SpecialOccasionEventModel = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        SpecialOccasionEventModel = BaseModel.extend({
            name: NAME,
            defaults: {
                id: null,
                name: "",
                startDate: null,
                endDate: null,
                type: ScheduleUtilities.EVENT_TYPES.INACTIVE,
                shifts: []
            },

            validation: {
                name: [
                    {
                        required: true,
                        minLength: 1,
                        msg: "LEFramework.entities.specialOccasion.errors.name.required"
                    },
                    {
                        maxLength: Config.validators.specialOccasions.maxNameLength,
                        msg: "LEFramework.entities.specialOccasion.errors.name.maxLength"
                    }
                ],
                startDate: [
                    {
                        required: true,
                        msg: "LEFramework.entities.specialOccasion.errors.timeFrame.required"
                    }
                ],
                endDate: [
                    {
                        required: true,
                        msg: "LEFramework.entities.specialOccasion.errors.timeFrame.required"
                    }
                ],
                "shifts.0": [
                    {
                        fn: function() {
                            // validate hierarchy the collection
                            var shiftsCollectionErrors = this.shiftsCollection.validate();
                            if (!_.isEmpty(shiftsCollectionErrors)) {
                                return "LEFramework.entities.specialOccasion.errors.generalError.internalError";
                            }
                        }
                    }
                ],
                duplicate: [
                    {
                        fn: function() {
                            if (this.errors.withinListDuplicated) {
                                return "LEFramework.entities.specialOccasion.errors.duplicate.event";
                            }
                        }
                    }
                ],
                inactiveDateLimit: [
                    {
                        fn: function() {
                            var inactiveEventMaxDaysDifferent = 30;
                            var startDate = this.getStartDate();
                            var endDate = this.getEndDate();

                            if (!_.isNull(startDate) && !_.isNull(endDate)) {
                                var daysDifferent = Math.floor(DateUtility.getDaysDiff(endDate, startDate)) + 1;
                                var dateLimitViolation = this.getType() === ScheduleUtilities.EVENT_TYPES.INACTIVE && daysDifferent > inactiveEventMaxDaysDifferent;
                                if (dateLimitViolation) {
                                    return "LEFramework.entities.specialOccasion.errors.offline.dateLimit.event";
                                }
                            }
                        }
                    }
                ]
            },

            initialize: function (options) {
                this.shiftsCollection = new ShiftsCollection(this.getShifts());
                this.errors = {withinListDuplicated: false};
                BaseModel.prototype.initialize.call(this, options);
            },

            getName: function() {
                return this.get(KEYS.NAME);
            },

            setName: function(name) {
                this.set(KEYS.NAME, name);
                if (this.isNew()) {
                    this._tryToSetId();
                }
            },

            getStartDate: function() {
                return this.get(KEYS.START_DATE);
            },

            setStartDate: function(date) {
                this.set(KEYS.START_DATE, date);
                if (this.isNew()) {
                    this._tryToSetId();
                }
            },

            getEndDate: function() {
                return this.get(KEYS.END_DATE);
            },

            setEndDate: function(date) {
                this.set(KEYS.END_DATE, date);
                if (this.isNew()) {
                    this._tryToSetId();
                }
            },

            getType: function () {
                return this.get(KEYS.TYPE);
            },

            getShifts: function () {
                return this.get(KEYS.SHIFTS);
            },

            setShifts: function(shifts) {
                this.set(KEYS.SHIFTS, shifts);
            },

            setType: function (type) {
                this.set(KEYS.TYPE, type);

                if (type !== ScheduleUtilities.EVENT_TYPES.CUSTOM){
                    this.shiftsCollection.reset();
                }
                else {
                    this.shiftsCollection.reset();
                    this.addShift();
                }
            },

            getShiftsCollection: function () {
                return this.shiftsCollection;
            },

            addShift: function (attr){
                attr = attr || {};
                var Model = this.shiftsCollection.model;
                this.shiftsCollection.add(new Model(attr));
            },

            removeShift: function(shiftModel) {
                this.shiftsCollection.remove(shiftModel);
            },

            _tryToSetId: function() {
                var name = this.getName();
                var startDate = this.getStartDate();
                var endDate = this.getEndDate();
                if (!_.isEmpty(name) && !_.isNull(startDate) && !_.isNull(endDate)) {
                    var id = (new Date()).getTime().toString();
                    this.set(KEYS.ID, id);
                }
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    SpecialOccasionEventModel.KEYS = KEYS;

    return SpecialOccasionEventModel;
});
